// src/components/Banner.js
import React from 'react';
import { Link } from 'react-router-dom';
import './Banner.css'; // Assuming you have a CSS file for styling

const Banner = ({ showImage = true, showText = true }) => {
  return (
  <div className="page-wrapper">
      {showImage && (
        <div className="banner-image-container">
          <img
            src="/images/banner-room.jpg"
            alt="Dental Banner"
            className="banner-image"
          />
        </div>
      )}

      {showText && (
        <div className="banner-container">
          <div className="banner-custom-line"></div>
          <h2 className="banner-title">Welcome</h2>
          <p className="banner-subtitle">Your smile is our priority!</p>
          <p className="banner-text">
            At Northside Dental Partners, we are committed to providing you with the highest quality dental care in a comfortable and welcoming environment. Explore our About Us page to learn more about our team!
          </p>
          <Link to="/about">
            <button className="banner-button">About Us</button>
          </Link>
          <p className="banner-subtext">Open 9:00 - 4:30, M-Th</p>
          <div className="banner-custom-line"></div>
        </div>
      )}
    </div>
);

};

export default Banner;

/*
<div className="banner-image-container">
        <img
          src="https://images.unsplash.com/photo-1535546125792-dd417e0f8f87?q=80&w=2574&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
          alt="Dental Banner Image 1"
          className="banner-image"
        />
      </div>

<div className="banner-image-container">
        <img
          src="https://images.unsplash.com/photo-1579295560051-3df968edb036?q=80&w=2574&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
          alt="Dental Banner"
          className="banner-image"
        />
      </div>
*/